<template>
  <div>
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Panel Profile</label>
          <el-input placeholder="Input data"
                    v-model="filters.methodology.panelProfile.value"
                    clearable></el-input>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Research type</label>
          <el-select
              v-model="filters.methodology.researchType.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getMetadataTagValues('research_type')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>CMI Tool</label>
          <el-select
              v-model="filters.methodology.cmiTool.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getMetadataTagValues('cmi_tool_type')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Design Method</label>
          <el-select
              v-model="filters.methodology.designMethod.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <template v-for="value in getMetadataTagValues('design_method')">
                <el-option v-if="value.value === 'Balanced Incomplete Block Design'"
                           :key="value.value" :label="value.value" :value="value.value">
                  <span style="float: left" v-b-tooltip.hover
                        :title="tooltips.bib">{{value.value}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                </el-option>
                <el-option v-else-if="value.value === 'Balance Complete Block Design'"
                           :key="value.value" :label="value.value" :value="value.value">
                  <span style="float: left" v-b-tooltip.hover
                        :title="tooltips.bcb">{{value.value}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                </el-option>
                <el-option v-else-if="value.value === 'Monadic Sequential'"
                           :key="value.value" :label="value.value" :value="value.value">
                  <span style="float: left" v-b-tooltip.hover
                        :title="tooltips.sequentialMonadic">{{value.value}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                </el-option>
                <el-option v-else
                           :key="value.value" :label="value.value" :value="value.value">
                  <span style="float: left">{{value.value}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                </el-option>
              </template>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Methodology</label>
          <el-select
              v-model="filters.methodology.methodology.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getMetadataTagValues('methodology')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Objective & Standards</label>
          <el-input placeholder="Input data"
                    v-model="filters.methodology.objectiveAndStandards.value"
                    clearable></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tooltips from '../../../constants/tooltips'

export default {
  name: 'MethodologyForm',
  props: {
    filters: Object,
    updateDropdownValues: Function,
    getMetadataTagValues: Function
  },
  data () {
    return {
      tooltips
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}
</style>
